import React from 'react'
import Gallery from '../components/Gallery'
import { NavLink } from 'react-router-dom'

import img1 from "../img/reference/smarthomeinstalace_1.jpg"
import img2 from "../img/reference/smarthomeinstalace_2.jpg"
import img3 from "../img/reference/smarthomeinstalace_3.jpg"
import img4 from "../img/reference/smarthomeinstalace_4.jpg"
import img5 from "../img/reference/smarthomeinstalace_5.jpg"

const Smarthomeinstalace = () => {
    const images = [
        img1, img2, img3, img4, img5
    ];

    return (
        <div className="services--content">
            <div className="services--content-volt">
                <h2>Vylepšete svůj domov s naší smart home instalací</h2>
                <p>
                    Chcete zvýšit komfort, bezpečnost a energetickou efektivitu Vašeho domova?
                    Instalace chytré domácnosti s naší firmou přináší řadu výhod:
                </p>

                <h3>Jak můžeme přeměnit vaši domácnost na chytrou?</h3>
                <ol>
                    <li>
                        <strong>Analýza a návrh:</strong>
                        <ul>
                            <li><strong>Bezplatná konzultace:</strong> Projednáme s vámi vaše potřeby a navrhneme optimální řešení.</li>
                            <li><strong>Individuální plán:</strong> Připravíme detailní plán instalace chytré domácnosti na míru.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Realizace:</strong>
                        <ul>
                            <li><strong>Instalace nových zařízení:</strong> Instalujeme a zapojíme chytrá zařízení, jako jsou termostaty, osvětlení, bezpečnostní kamery a další.</li>
                            <li><strong>Integrace se stávajícími systémy:</strong> Upgradujeme vaši stávající elektroinstalaci na chytrou domácnost bez zbytečných komplikací.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Testování a uvedení do provozu:</strong>
                        <ul>
                            <li><strong>Komplexní testování:</strong> Otestujeme všechny funkce a zajistíme, že vše funguje bezchybně.</li>
                            <li><strong>Školení:</strong> Naučíme vás, jak efektivně využívat nový systém chytré domácnosti.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Podpora a údržba:</strong>
                        <ul>
                            <li><strong>Pravidelná údržba:</strong> Nabízíme servisní smlouvy pro zajištění dlouhodobé spolehlivosti.</li>
                            <li><strong>Rychlá podpora:</strong> Jsme zde pro vás, pokud budete potřebovat pomoc nebo konzultaci.</li>
                        </ul>
                    </li>
                </ol>

            </div>

            <Gallery images={images} />

            <div className="services--content-white">
                <h3>Proč Zvolit Naši Firmu pro Instalaci Smart Home?</h3>
                <ol>
                    <li>
                        <strong>Profesionální přístup:</strong>
                        <ul>
                            <li><strong>Zkušený tým odborníků:</strong> Naši technici mají bohaté zkušenosti s instalací chytrých domácností a pravidelně se školí v nejnovějších technologiích.</li>
                            <li><strong>Individuální řešení:</strong> Přizpůsobíme chytrou domácnost přesně vašim potřebám a požadavkům.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Kompletní služby:</strong>
                        <ul>
                            <li><strong>Komplexní instalace:</strong> Zajistíme vše od návrhu systému až po jeho plnou realizaci.</li>
                            <li><strong>Upgrade stávajících instalací:</strong> Přeměníme vaši stávající elektroinstalaci na moderní chytrou domácnost bez nutnosti rozsáhlých stavebních úprav.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Moderní technologie:</strong>
                        <ul>
                            <li><strong>Automatizace a kontrola:</strong> Ovládejte osvětlení, vytápění, bezpečnostní systémy a další zařízení pomocí mobilní aplikace nebo hlasových asistentů.</li>
                            <li><strong>Energetická efektivita:</strong> Ušetřete na energiích díky inteligentnímu řízení spotřeby a automatizaci.</li>
                            <li><strong>Bezpečnost:</strong> Zvýšíme bezpečnost vašeho domova pomocí chytrých zámků, kamerových systémů a senzorů.</li>
                        </ul>
                    </li>
                </ol>



            </div>

            <nav>
                <NavLink to="/kontakt" activeClassName="active">
                    zjistěte jak můžeme pomoci vám
                </NavLink>
            </nav>
        </div>
    )
}

export default Smarthomeinstalace